<template>
  <!-- 登录弹窗 -->
  <div class="md-popup md-popup-login on" v-if="showLoginDialog">
    <i class="pop-close" data-tag="login" @click="cancelDialog"></i>
    <h2>登录</h2>
    <form id="j_getLoginForm">
      <menu class="info-list">
        <li class="list-item">
          <input
            type="tel"
            name="mobile"
            v-model="mobile"
            autocomplete="off"
            class="textbox"
            maxlength="11"
            placeholder="输入手机号"
          />
        </li>
        <li class="list-item">
          <input
            type="tel"
            name="verifycode"
            v-model="verifycode"
            maxlength="6"
            class="textbox"
            placeholder="输入验证码"
          />
          <span
            class="get-captcha tc f26"
            :class="ticker.indexOf('s')>-1?'send-fade':'' "
            @click="onGetVerifyCode"
          >{{ticker}}</span>
        </li>
      </menu>
      <p class="btn-bar tc" data-tag="login" @click="onLogin">
        <span class="btn-item btn-login f32">立即登录</span>
      </p>
    </form>
  </div>
</template>

<script>
import service from '../../api/service'

export default {
    props: ['showLoginDialog'],
    data() {
        return {
            mobile: '', //手机号
            ticker: '获取验证码',
            verifycode: ''
        }
    },
    // watch: {
    //     ['popStatus.login'](nv, ov) {
    //         let me = this;

    //         // 修复ios11弹出输入框bug
    //         if (_zax.device.iphone && _ua.match(/iphone os 11/i) == "iphone os 11") {
    //             let body = $('body');

    //             if (nv) {
    //                 me.setBrowserInfo({
    //                     'scrollTop': $(document).scrollTop()
    //                 });
    //                 body.css('top', -me.browserInfo.scrollTop);
    //                 body.addClass('body-fix');
    //             } else {
    //                 body.removeClass('body-fix');
    //                 body.css('top', '0');
    //                 $(document).scrollTop(me.browserInfo.scrollTop);
    //             }
    //         }
    //     }
    // },
    methods: {
        async onLogin() {
            let me = this
            let mobile = me.mobile
            let verifycode = me.verifycode

            if (!mobile) {
                _zax.ui.toast('请填写手机号')
                return
            } else if (!_zax.regexForm.mobile(mobile)) {
                _zax.ui.toast('请填写正确的手机号')
                return
            } else if (!verifycode) {
                _zax.ui.toast('请填写短信验证码')
                return
            }
            console.log(service)
            let res = await service.userLogin(mobile, verifycode)
            console.log(res)
            if (res) {
                if (res.code == '200') {
                    _zax.ui.toast('登录成功')
                    this.cancelDialog()
                    // location.reload(true);
                    setTimeout(() => {
                        me.$parent.$parent.$children[0]._initPage()
                        // location.reload(true)
                    }, 300)
                } else {
                    _zax.ui.toast(res.message || '请在APP设置中清空缓存，退出APP重试')
                }
                // setUserCode(_zax.cookie.get(me.cfg.token));
                // me.$parent.setPopStatus({
                //     login: false,
                // })
            }
        },
        async onGetVerifyCode(e) {
            //发送验证码
            let me = this
            let mobile = me.mobile
            let verifycode = me.verifycode
            if (!mobile) {
                _zax.ui.toast('请填写手机号')
                return
            } else if (!_zax.regexForm.mobile(mobile)) {
                _zax.ui.toast('请填写正确的手机号')
                return
            } else {
                if (me.ticker != '获取验证码') {
                    return
                } else {
                    me.ticker = '60 s'
                    service.sendVerifyCode(mobile)
                    let myticker = setInterval(() => {
                        let tck = parseInt(me.ticker.replace(' s', ''))
                        if (tck > 0) {
                            me.ticker = tck - 1 + ' s'
                        } else {
                            clearInterval(myticker)
                            me.ticker = '获取验证码'
                        }
                    }, 1000)
                }
            }
        },
        cancelDialog() {
            this.$emit('cancel', 'login')
            _zax.ui.mask.hide()
        }
    },
    created() {
        let me = this
        // if (me.cfg.machine.indexOf('test') > -1) {
        //     me.mobile = '13472792921';
        //     me.verifycode = '999999';
        // }
    },
    mounted() {
        let me = this
    },
    beforeDestroy() {
        let me = this
        // window.removeEventListener("scroll", me.onScroll)
    }
}
</script>



// WEBPACK FOOTER //
// src/views/components/Login-dialog.vue